export const SEQUENCER_TYPE = [
    { 'label': 'Miseq', 'value' : 'Miseq'},
    { 'label': 'NovaSeq', 'value': 'NovaSeq'}
]

export const EXCLUSIVE_OPTIONS = [
    {'label': 'Independent', 'value': 'independent'},
    {'label': 'Product', 'value': 'product'},
    {'label': 'Batch-wise', 'value': 'batch'},
    {'label': 'Exclusive', 'value': 'exclusive'}
];

export const LIB_PREP_FINISH = "LIB_PREP_FINISH";

export class ReadBlock {
    name: string;
    fraction: number;
    libraries: any[];
    count: number;
    color: any;
    icon: any;
    dueDate: Date;
    libID: string[]=[];
    readLength:number;
    gxp: boolean;
}

export class FlowCellBlock {
    name: string;
    fraction: number;
    icon: any;
}

export const EMPTY_BLOCK_NAME = "Empty Block";

export class Lane {
    laneName: string;
    constraintId: string = 'no';
    constraintIdChooser: string;
    constraintType: string = 'no';
    laneBlocks: LaneBlock[] = [];
    phiXPercentage: number = 0;
    totalCapacity: number;
    occupiedCapacity: number = 0;
    occupiedPercentage: number = 0;
    openForPlanning = true;
    receivedFromNGLIMS = false;
    status: string;
    finalConcentration: number;
    poolingRun: number;
    eppiPosition: number;
    dnPfiles: string[] = [];
    hamiltonFileGenerated: boolean;
    gxp: boolean = false
    plateBarcodesForPoolingRun: string[] = []
}

export class LaneBlock {
    name: string;
    ipus: any[] = [];
    weight: number = 0;
    weightPercentage: number = 0;
    color: string;
}

export const PHIX_BLOCK_NAME = "PhiX";
export const OVERDUE_BLOCK_NAME = "Overdue";
export const DUELESS_BLOCK_NAME = "Dueless";
export const DUEMORE_BLOCK_NAME = "Duemore";

export const PHIX_COLOR = "#58a4e6";
export const OVERDUE_COLOR = "#e97474";
export const DUELESS_COLOR = "#fdb872";
export const DUEMORE_COLOR = "#6AA84F";

export const LANE_BLOCKS = [PHIX_BLOCK_NAME, OVERDUE_BLOCK_NAME, DUELESS_BLOCK_NAME, DUEMORE_BLOCK_NAME];

export const EXCLUSIVE_CONSTRAINT = "exclusive";
export const PRODUCT_CONSTRAINT = "product";
export const BATCH_CONSTRAINT = "batch";
export const INDEPENDENT_CONSTRAINT = "independent";
export const UPDATE_SEQUENCING_STEPS_OPTION = 'UPDATE_SEQUENCE';
export const UPDATE_CONSTRAINTS_OPTION ='UPDATE_CONSTRAINTS';
export const UPDATE_MISSINGREADS_OPTION ='UPDATE_MISSINGREADS';
export const UPDATE_STATUS_OPTION ='UPDATE_STATUS';
export const UPDATE_RAW_DATA_DELIVERY_DATE ='UPDATE_RAW_DATA_DELIVERY_DATE';

export class RunPlanDTO {
    constraintId: string;
    constratintType: string;
    calculatedValue: number;
    laneInfo: string;
    laneCapacity: number;
    dueDate: number;
    remainingCapacity: number;
    tagDependencyList: string[];
    libraryId: string[];
    weight: number; 
    ipuId: string;
    phiXPercentage: number;
    occupiedCapacity: number;
    occupiedPercentage: number;
    gxp: boolean;
}

export class CalculatePlanDTO {
    sequencerType: string;
    labId: string;
    status: string;
    libraryIds: string[] = [];
    runPlanDTOMap: any;
    laneInfos: string[] = [];
    noConstraint: boolean = false;
    constraintIds: string[] = [];
    runId: string;
}

export const REMAINING_LANE_NAME = 'remaining';


export class LibData{
    libraryId: string;
    constraintType: string;
    constraintId: string;
    missingReads: number;
    dueDate:Date;
}

export const RUN_PLANNED = "RUN_PLANNED";
export class LaneViewDataDTO {
    laneId: string;
    constraintId: string;
    totalLibIds :number= 0;
    totalReadsCount: string;
    readsPercentage: number;
    phixPercentage:number;
    laneBlocks: LaneBlock[] = [];
    readsForLane: string = "N/A";
    unknownReads: string = "N/A";
    totalReads: string = "N/A";
    q30Rate: string = "N/A";
    unknownTags: Map<string, any> = new Map();
    finalConcentration: number;
    userInputFinalConc: number;
    statusOfTheLane: string;
    poolingRun: number;
    eppiPosition: number;
    dnPfiles: string[] = [];
    hamiltonFileGenerated: boolean;
    allLibsDPWaiting: boolean;
    gxp:boolean;
    plateBarcodesForPoolingRun: string[]
}

export class LaneBlockForDueDate {
    name: string;
    ipus: any[] = [];
    weight: number = 0;
    weightPercentage: number = 0;
    color: string;
}

export const DP_STARTED = 'DP_STARTED';
export const DP_WAITING = 'DP_WAITING';
export const DP_READY = 'DP_READY';
export const DP_COMPLETED = 'DP_COMPLETED';
export const RUN_SCHEDULED = 'RUN_SCHEDULED';
export const MANUAL_RUNQC_FINISHED = 'MANUAL_RUNQC_FINISHED';
export const PREPARE_DATA_FOR_ANALYSIS = 'PREPARE_DATA_FOR_ANALYSIS';
export const PA_STARTED = 'PA_STARTED';
export const SEQ_RUN_FINISHED = 'SEQ_RUN_FINISHED';
export const SEQ_RUN_STARTED = 'SEQ_RUN_STARTED';